module.exports = __webpack_public_path__ + "static/media/member-check-in.0deab923.svg";